import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/success.png'


const _withScopeId = n => (_pushScopeId("data-v-076ddfc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exchange-model" }
const _hoisted_2 = {
  key: 0,
  class: "exchange-choose"
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "limit-text" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "number" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "童币", -1))
const _hoisted_8 = { class: "stepper" }
const _hoisted_9 = { class: "step" }
const _hoisted_10 = {
  key: 1,
  class: "exchange-success"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-text" }, "兑换成功", -1))

import { Toast } from 'vant'
import { createIntegralOrder } from '@/apis/public';
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
  goodInfo: {
    type: Object
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()


const goodInfo = ref(props.goodInfo)
const handleClose = () => {
  if (isExchangeLoad.value) return
  emit('close')
}
const num = ref(props.goodInfo.purchaseMin)
const handleChangeNum = (i) => {
  num.value = num.value + i
  if (num.value < props.goodInfo.purchaseMin) {
    num.value = props.goodInfo.purchaseMin
  }
  if (num.value > props.goodInfo.stockNum) {
    num.value = props.goodInfo.stockNum
  }
  if (num.value > props.goodInfo.purchaseMax) {
    num.value = props.goodInfo.purchaseMax
  }
}
const isExchangeSuccess = ref(false)
const isExchangeLoad = ref(false)
const handleExchange = async () => {
  if (isExchangeLoad.value) return
  isExchangeLoad.value = true
  try {
    const res = await createIntegralOrder({
      goodNo: goodInfo.value.goodNo,
      payIntegral: (goodInfo.value.goldPayPrice * num.value),
      nums: num.value
    })
    isExchangeLoad.value = false
    if (res.code === 0) {
      isExchangeSuccess.value = true
    } else {
      Toast(res.message)
    }
  }catch {
    isExchangeLoad.value = false
  }
}
const handleToCard = () => {
  router.push({
    name: 'Card'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isExchangeSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(goodInfo.value.goodName), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(goodInfo.value.purchaseMin) + "件起购 限购" + _toDisplayString(goodInfo.value.purchaseMax) + "件", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(goodInfo.value.goldPayPrice * num.value), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(['jian', num.value <= goodInfo.value.purchaseMin ? 'disabled' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeNum(-1)))
              }, "-", 2),
              _createElementVNode("div", _hoisted_9, _toDisplayString(num.value), 1),
              _createElementVNode("div", {
                class: _normalizeClass(['jia', (num.value >= goodInfo.value.purchaseMax || num.value >= goodInfo.value.stockNum) ? 'disabled' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeNum(1)))
              }, "+", 2)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['submit-btn']),
            onClick: handleExchange
          }, "确定兑换"),
          _createElementVNode("div", {
            class: "cancel-btn",
            onClick: handleClose
          }, "取消兑换")
        ]))
      : _createCommentVNode("", true),
    (isExchangeSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", {
            class: "submit-btn",
            onClick: handleToCard
          }, "去领取")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})